module.exports = new __parcel__URL__("gosat-based-ch4budget-yeargrid-v1.thumbnails.posterior.total.e0f66b64.png").toString();